<template>
    <el-dialog title="下载客户端" width="654px" top="260px" :visible="isShowDownload" @close="closeDownload">
        <div class="download-content" v-for="(item, index) in info" :key="item.id" @click="changeItem(item, index)">
            <div
                :class="['logo', active === item.id ? 'active' : '', (active === item.id && item.id === 2) ? 'scanl-code' : '']">
                <vue-qr v-if="active === 2 && index === 1" class="codeQr" :size="120" colorDark="#000" colorLight="#fff"
                    :margin="0" :logoSrc="lgoImg" :text="item.pkg_url"></vue-qr>
                <img v-else :src="item.img" alt="">
            </div>
            <span>{{ item.type }}</span>
            <el-button plain :class="active === item.id ? 'active-button' : ''" @click="downloadItem(item)">下载安装</el-button>
        </div>
        <div class="more-down">
            <span @click="checkMoreVersion">更多版本</span>
        </div>
    </el-dialog>
</template>

<script>
import QRCode from 'qrcodejs2'
import VueQr from 'vue-qr'
export default {
    components: { VueQr },
    data () {
        return {
            info: [
                {
                    id: 1,
                    img: require('../../assets/download/windows.png'),
                    type: 'Windows',
                },
                {
                    id: 2,
                    img: require('../../assets/download/android.png'),
                    type: 'Android',
                },
                {
                    id: 3,
                    img: require('../../assets/download/office.png'),
                    type: 'Office PPT插件',
                }
            ],
            lgoImg: require('../../assets/download/android.png'),
            active: 1,
        }
    },
    props: {
        isShowDownload: {
            type: Boolean,
            default: false
        },
        downloadInfo: [Object],
    },

    mounted () {
        this.$set(this.info, 0, { ...this.info[0], ...this.downloadInfo.win_socoton })
        this.$set(this.info, 1, { ...this.info[1], ...this.downloadInfo.android })
        this.$set(this.info, 2, { ...this.info[2], ...this.downloadInfo.ppt_addin })
    },

    methods: {
        changeItem (item) {
            const { id } = item
            this.active = id
        },
        // 下载
        downloadItem (item) {
            const { id, pkg_url } = item
            // if (this.active !== id) {
            //     return false
            // }
            window.location.href = pkg_url
        },
        closeDownload () {
            this.$emit('closeDownload')
        },
        // 查看更多版本
        checkMoreVersion () {
            this.$emit('closeDownload')
            let href = this.$router.resolve({
                name: 'MoreVersion',
            })
            window.open(href.href, '_blank')
        },
    }

}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__header {
    height: 50px;
    line-height: 50px;
    border: 1px solid #F1F4F6;
}

/deep/ .el-dialog__title {
    font-size: 20px;
    color: #2881CD;
}

/deep/ .el-dialog__body {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    padding: 50px 20px 70px;

    .download-content {
        display: flex;
        flex-direction: column;

        .logo {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 120px;
            height: 120px;
            border-radius: 50%;
            background: #F8F8F8;

            img {
                line-height: 120px;
                // width: 52px;
                // height: 52px;
            }
        }

        .active {
            box-sizing: border-box;
            border: 1px solid #2881CD;
        }

        span {
            margin: 16px 0;
        }

        .active-button {
            color: #fff;
            background: #2881CD;
        }

        // 扫描二维码
        .scanl-code {
            border-radius: 0;
            border: none;

            img {
                width: 100%;
                height: 100%;
            }
        }
    }

    .more-down {
        position: absolute;
        right: 60px;
        bottom: 30px;
        color: #2881CD;
        cursor: pointer;
        // width: 200px;
    }

}
</style>


// WEBPACK FOOTER //
// src/view/Login/DownloadClient.vue